export default __webpack_public_path__ + "static/media/av.5bd5ba57.png";